export default __webpack_public_path__ + "static/media/Damaso_No8Open1.8d56e7bd.jpg";